import * as React from 'react';
import { SVGProps } from 'react';

const IconFunnelRemoveSizeXs = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 12" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1 2h10v.586a1 1 0 0 1-.293.707L7.293 6.707A1 1 0 0 0 7 7.414V10l-2 1V7.414a1 1 0 0 0-.293-.707L1.293 3.293A1 1 0 0 1 1 2.586V2Zm3.525 1.732.768.768-.768.768.707.707L6 5.207l.768.768.707-.707-.768-.768.768-.768-.707-.707L6 3.793l-.768-.768-.707.707Z"
    />
  </svg>
);
export default IconFunnelRemoveSizeXs;
